import { render, staticRenderFns } from "./off-site-mailbox-log.vue?vue&type=template&id=2bde2efa&scoped=true&"
import script from "./off-site-mailbox-log.vue?vue&type=script&lang=js&"
export * from "./off-site-mailbox-log.vue?vue&type=script&lang=js&"
import style0 from "./off-site-mailbox-log.vue?vue&type=style&index=0&id=2bde2efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde2efa",
  null
  
)

export default component.exports